import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';
import NoRiskToleranceAlert from './NoRiskToleranceAlert';

export default fr.metaOverride({ base: BaseOverride })
  .nameOverride(['additionalDetailTitle'], {
    _component: () => NoRiskToleranceAlert,
  }, { ordinal: 200 });
